import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import { Form, Field } from 'react-final-form'
import cn from 'classnames'
import { maxStrLength } from '../../utilities/commonValidators'
import Autocomplete from '../autoComplete/AutoComplete'
import { TERMS_AND_CONDITION_STATUS_OPTIONS, TICKET_STATUS_OPTIONS, clientSearchFormValues } from './utils'

export default function ClientsTableSearchForm ({
  onSubmit,
  onClear,
  disabled = false,
  initialValues = {},
  hideButtons = {},
  showTicketStatusSelect = false,
  hideTermsAndConditionStatus = false,
  handleExportClients,
  clients = []
}) {
  function handleClear (form) {
    form.reset({})
    onClear()
  }

  function valuesWithoutHiddenFilters (values) {
    if (!hideTermsAndConditionStatus) return values
    return { ...values, termsAndConditionStatus: undefined }
  }

  const formKey = [
    initialValues.accountId,
    initialValues.accountName,
    initialValues.contactName,
    initialValues.phoneNumber,
    initialValues.termsAndConditionStatus,
    initialValues.ticketStatusSelect
  ].join('|')

  return (
    <Form
      onSubmit={(values) => onSubmit(valuesWithoutHiddenFilters(values))}
      initialValues={initialValues}
      key={formKey}
      destroyOnUnregister>
      {({ handleSubmit, form, values }) => (
        <form
          className={
            cn(styles.form, {
              [styles.multipleInputs]: showTicketStatusSelect
            })}
          onSubmit={handleSubmit}>
          {/*
            TODO This form-control is the last bootstrap we have in this component. Unfortunately replacing
            this styling with our own code is just out of scope for the current change.
          */}
          <div className={styles.inputs}>
            <label className={`${styles.label}`}>
              Account ID
              <Field name='accountId' validate={maxStrLength(100)}>
                {({ input }) => (
                  <input
                    {...input}
                    type='text'
                    className={cn(styles.input, 'form-control')}
                    autoComplete='off'
                    maxLength={100}
                  />
                )}
              </Field>
            </label>
            <label className={`${styles.label}`} htmlFor='autocomplete_clients_account_name'>
              Account Name
              <Field name='accountName' validate={maxStrLength(100)}>
                {({ input }) => (
                  <Autocomplete
                    name='accountName'
                    data={clients}
                    value={input.value}
                    id='autocomplete_clients_account_name'
                    onSelect={(value) => {
                      input.onChange(value ? value.name : '')
                    }}
                    onChange={(value) => {
                      input.onChange(value || '')
                    }}
                    onClear={() => input.onChange('')}
                  />
                )}
              </Field>
            </label>
            <label className={`${styles.label}`}>
              Contact Name
              <Field name='contactName' validate={maxStrLength(100)}>
                {({ input }) => (
                  <input
                    {...input}
                    type='text'
                    className={cn(styles.input, 'form-control')}
                    autoComplete='off'
                    maxLength={100}
                  />
                )}
              </Field>
            </label>
            <label className={`${styles.label}`}>
              Phone Number
              <Field name='phoneNumber' validate={maxStrLength(100)}>
                {({ input }) => (
                  <input
                    {...input}
                    type='text'
                    className={cn(styles.input, 'form-control')}
                    autoComplete='off'
                    maxLength={100}
                  />
                )}
              </Field>
            </label>
          </div>
          {(!hideTermsAndConditionStatus || showTicketStatusSelect) &&
            <div className={cn(styles.inputs, styles.secondRow)}>
              {!hideTermsAndConditionStatus &&
                <label className={styles.label}>
                  T&C Status
                  <Field name='termsAndConditionStatus'>
                    {({ input }) => (
                      <select
                        {...input}
                        className={cn(styles.input, 'form-control')}>
                        <option value=''></option>
                        {TERMS_AND_CONDITION_STATUS_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    )}
                  </Field>
                </label>
              }
              {showTicketStatusSelect &&
                <label className={styles.label}>
                  Filter by Ticket Status
                  <Field name='ticketStatusSelect'>
                    {({ input }) => (
                      <select
                        {...input}
                        className={cn(styles.input, 'form-control')}>
                        <option value=''></option>
                        {TICKET_STATUS_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    )}
                  </Field>
                </label>
              }
            </div>
          }
          <div className={styles.btns}>
            {!hideButtons.export &&
              <button
                type='button'
                onClick={() => handleExportClients(clientSearchFormValues(valuesWithoutHiddenFilters(values)))}
                className={cn(styles.btn, 'dis-btn dis-btn-primary-dk dis-btn-sm')}
                disabled={disabled}>
                Export
                <i className='material-icons dis-btn-icon'>get_app</i>
              </button>
            }
            <div>
              <button
                type='submit'
                className={cn(styles.btn, 'dis-btn dis-btn-success dis-btn-sm')}
                disabled={disabled}>
                Search
                <i className='material-icons dis-btn-icon'>search</i>
              </button>
              {!hideButtons.clear &&
                <button
                  type='button'
                  onClick={() => handleClear(form)}
                  className={cn(styles.btn, 'dis-btn dis-btn-white dis-btn-sm')}
                  disabled={disabled}>
                  Clear
                  <i className='material-icons dis-btn-icon'>clear</i>
                </button>
              }
            </div>
          </div>
        </form>
      )}
    </Form>
  )
}

ClientsTableSearchForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  handleExportClients: PropTypes.func,
  disabled: PropTypes.bool,
  initialValues: PropTypes.shape({
    accountName: PropTypes.string,
    accountId: PropTypes.string,
    contactName: PropTypes.string,
    phoneNumber: PropTypes.string,
    termsAndConditionStatus: PropTypes.string,
    ticketStatusSelect: PropTypes.string
  }),
  hideButtons: PropTypes.shape({
    clear: PropTypes.bool,
    export: PropTypes.bool
  }),
  showTicketStatusSelect: PropTypes.bool,
  hideTermsAndConditionStatus: PropTypes.bool,
  clients: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }))
}
